import { createApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { PaymentStripeComponent } from './app/payment-stripe/payment-stripe.component';
import { appConfig } from './app/app.config';
import { TokenizationStripeComponent } from './app/tokenization-stripe/tokenization-stripe.component';

async function bootstrap() {
  const appRef = await createApplication(appConfig);

  const paymentStripe = createCustomElement(PaymentStripeComponent, {
    injector: appRef.injector,
  });

  const tokenizeStripe = createCustomElement(TokenizationStripeComponent, {
    injector: appRef.injector,
  });

  customElements.define('acord-payment', paymentStripe);
  customElements.define('acord-tokenization', tokenizeStripe);
}

bootstrap()
  .then(() => console.log('Insurepay Embed Bootstrap Complete'))
  .catch((error) => console.error(error));
